import { render, staticRenderFns } from "./SubjectItemProduct.vue?vue&type=template&id=49a93380&scoped=true"
import script from "./SubjectItemProduct.vue?vue&type=script&lang=js"
export * from "./SubjectItemProduct.vue?vue&type=script&lang=js"
import style0 from "./SubjectItemProduct.vue?vue&type=style&index=0&id=49a93380&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a93380",
  null
  
)

export default component.exports